import React, { FunctionComponent } from 'react'

import { Box, Flex, xsBumps } from '../atoms'
import { OptionTile } from './OptionTile'

export interface BooleanInputProps {
  name: string
  value: boolean | undefined
  onSelect: (value: boolean) => void

  trueLabel?: string
  falseLabel?: string
}

export const BooleanInput: FunctionComponent<BooleanInputProps> = ({
  name,
  value,
  onSelect,

  trueLabel = 'Yes',
  falseLabel = 'No',
}) => (
  <Flex flexDirection='row' width={[1, 1, 3 / 5]}>
    <Box width={1} mr={xsBumps}>
      <OptionTile
        name={name}
        value={true}
        text={trueLabel}
        onSelect={onSelect}
        checked={value === true}
      />
    </Box>
    <Box width={1}>
      <OptionTile
        name={name}
        value={false}
        text={falseLabel}
        onSelect={onSelect}
        checked={value === false}
      />
    </Box>
  </Flex>
)
